import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ADMIN_TOKEN_KEY = "weave_admin_token";

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem(ADMIN_TOKEN_KEY);
    if (token && config.url && config.url.startsWith("/admin")) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const adminAuth = {
    getToken: () => localStorage.getItem(ADMIN_TOKEN_KEY),
    setToken: (token) => localStorage.setItem(ADMIN_TOKEN_KEY, token),
    clear: () => localStorage.removeItem(ADMIN_TOKEN_KEY),
};

export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_opportunity-unlock/artifacts/p2ge1ub1_WEAVE-LOGO%202024.png";
